import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

export const getError = (error: FetchBaseQueryError | SerializedError) => {
  const defaultMessage = 'Aconteceu um erro desconhecido'
  if ('status' in error) {
    const { message, errors } = error.data as {
      message?: string
      errors?: { [key: string]: string[] }
    }
    if (errors) {
      return Object.values(errors)
        .flat()
        .map((err) => <li key={err}>{err}</li>)
    } else if (message) return message
    else return defaultMessage
  } else return error.message ?? defaultMessage
}

export const removeNullProps = (obj: { [key: string]: any }) => {
  for (const prop in obj) {
    if (
      obj[prop] === null ||
      obj[prop] === undefined ||
      (typeof obj[prop] === 'string' && obj[prop].trim() === '')
    ) {
      delete obj[prop]
    }
  }
  return obj
}

export const isEmptyObj = (obj: object) => {
  return Object.keys(obj).length === 0
}

export function noop(): void {}

export const shouldRefresh = (error: FetchBaseQueryError) => {
  const isError = (code: number) => code === 401
  if (typeof error.status === 'number' && isError(error.status)) return true
  if (error.status === 'PARSING_ERROR') return isError(error.originalStatus)
  return false
}
